import { render, staticRenderFns } from "./seminarInfo.vue?vue&type=template&id=20ee026c&scoped=true&"
import script from "./seminarInfo.vue?vue&type=script&lang=js&"
export * from "./seminarInfo.vue?vue&type=script&lang=js&"
import style0 from "./seminarInfo.vue?vue&type=style&index=0&id=20ee026c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ee026c",
  null
  
)

export default component.exports